module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "header-box add-bg"
  }, [_c('div', {
    staticClass: "c-header clearfix"
  }, [_vm._m(0), _c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      class: {
        active: index == _vm.currentPage
      },
      on: {
        "click": function($event) {
          return _vm.goUrl(item.url)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _vm._m(1), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/header-logo-orange-xd.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-1"
  }, [_c('h2', [_c('i', {
    staticClass: "left"
  }), _vm._v("四大业务方向,共同发力"), _c('i', {
    staticClass: "right"
  })]), _c('ul', [_c('li', [_c('img', {
    staticStyle: {
      "margin-top": "65px"
    },
    attrs: {
      "src": require("./images/icon-fenqi.png"),
      "alt": ""
    }
  })]), _c('li', [_c('h2', [_vm._v("分期业务")]), _c('p', [_vm._v("支持消费分期、现金分期")]), _c('p', [_vm._v("为猪八戒网用户提供先消费后付款服务")]), _c('p', [_vm._v("更为有资金需要的用户提供短期小额的")]), _c('p', [_vm._v("现金周转服务")]), _c('p', [_vm._v("纯线上 放款快 分期灵活")])]), _c('li', [_c('h2', [_vm._v("小微业务")]), _c('p', [_vm._v("为小微企业及企业主提供经营贷款")]), _c('p', [_vm._v("快速解决中小微企融资问题")]), _c('p', [_vm._v("快捷方便")])]), _c('li', [_c('img', {
    staticStyle: {
      "margin-top": "45px"
    },
    attrs: {
      "src": require("./images/icon-xiaowei.png"),
      "alt": ""
    }
  })]), _c('li', [_c('img', {
    staticStyle: {
      "margin-top": "62px"
    },
    attrs: {
      "src": require("./images/icon-chain.png"),
      "alt": ""
    }
  })]), _c('li', [_c('h2', [_vm._v("供应链金融")]), _c('p', [_vm._v("连通猪八戒网服务商和雇主两端用户,")]), _c('p', [_vm._v("提供应收账款融资服务")]), _c('p', [_vm._v("保证上下游资金链稳定,助力交易顺利达成")])]), _c('li', [_c('h2', {
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_vm._v("抵押贷款")]), _c('p', [_vm._v("为有需求的用户提供房抵贷")]), _c('p', [_vm._v("放款快,费率低,通过率快")])]), _c('li', [_c('img', {
    staticStyle: {
      "margin-top": "58px"
    },
    attrs: {
      "src": require("./images/icon-loan.png"),
      "alt": ""
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-2"
  }, [_c('h2', [_c('i', {
    staticClass: "left"
  }), _vm._v("更多小微场景 建设普惠金融"), _c('i', {
    staticClass: "right"
  })]), _c('ul', [_c('li', {
    staticClass: "right-margin bottom-margin"
  }, [_c('img', {
    attrs: {
      "src": require("./images/scene-1.png"),
      "alt": ""
    }
  }), _c('p', [_vm._v("循环额度")])]), _c('li', {
    staticClass: "right-margin bottom-margin"
  }, [_c('img', {
    attrs: {
      "src": require("./images/scene-2.png"),
      "alt": ""
    }
  }), _c('p', [_vm._v("起点分期")])]), _c('li', {
    staticClass: "bottom-margin"
  }, [_c('img', {
    attrs: {
      "src": require("./images/scene-3.png"),
      "alt": ""
    }
  }), _c('p', [_vm._v("提前收款")])]), _c('li', {
    staticClass: "right-margin"
  }, [_c('img', {
    attrs: {
      "src": require("./images/scene-4.png"),
      "alt": ""
    }
  }), _c('p', [_vm._v("八戒借条")])]), _c('li', {
    staticClass: "right-margin"
  }, [_c('img', {
    attrs: {
      "src": require("./images/scene-5.png"),
      "alt": ""
    }
  }), _c('p', [_vm._v("教育分期")])]), _c('li', [_c('img', {
    attrs: {
      "src": require("./images/scene-6.png"),
      "alt": ""
    }
  }), _c('p', [_vm._v("宠物分期")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-43f94994", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43f94994","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@zbj/vue-mixin-loader?{"mixinPath":"D://zhubajie//Project//nodejs-zbjfins-web//app//resource//global//css//mixin//mixin.less"}!./app/resource/page/index/views/sceneService.vue
// module id = 1194
// module chunks = 2